<div class="main-nav">
  <div class="main-nav__title">
    <ui-organism-main-title [text]="mainText" />
  </div>
</div>
